function appendDataLabel(
  header: NodeListOf<HTMLTableCellElement>,
  rows: HTMLTableRowElement[]
) {
  header.forEach((th, index) => {
    const { innerText: label } = th;
    rows.forEach((row) => {
      const column = row.querySelector(
        `tr td:nth-child(${index + 1})`
      ) as HTMLTableCellElement;
      column.setAttribute('data-label', label);
    });
  });
}

export default appendDataLabel;
